import styled from "styled-components";

export const ThumbNailService = styled.div`
  height: auto;
  border: 1px solid #eaeaea;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 20px;
  max-width: 234,13px;

  .service-backgound {
    height: 85px;
  }
  .thumbnail-item {
    /* height: auto; */
    height: 120px;
  }
  .thumbnail-header {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
  }
  .thumbnail-header {
    padding: 20px 20px 0px 20px;
  }
  .thumbnail-body {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    padding: 5px 20px 0px 20px;
  }
  .thumbnail-body p {
	  white-space: pre-line;
    max-height: 40px;
  }
  .thumbnail-bottom {
    padding: 20px;
  }
  @media only screen and (min-width: 769px) and (max-width: 970px) {
    .thumbnail-item {
      height: 170px;
    }
  }

  .tooltipStyleCus {
    z-index: 99999999;
    background-color: #637381;
    color: #fff;
    opacity: 1;
    font-weight: normal;
    font-size: 90%;
  }
`;

export const TagOptionService = styled.span<{ backgroundColor?: string; textColor?: string }>`
  background: #e8e8e8;
  border-radius: 15px;
  font-size: 0.775rem;
  font-weight: bold;
  color: rgb(99, 115, 129);
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TagSponsorService = styled.span`
	background: #0971A2;
	border-radius: 5px;
	font-size: 11px;
	padding: 3px 10px;
	font-weight: bold;
	color: #FFFFFF;
  bottom: 0;
  position: absolute;
  right: 0;
  margin-bottom: 20px;
  margin-right: 20px;
`;
